__turbopack_context__.v({
  "button": "user-menu-trigger-module-scss-module__4BL5aa__button",
  "icon": "user-menu-trigger-module-scss-module__4BL5aa__icon",
  "name": "user-menu-trigger-module-scss-module__4BL5aa__name",
  "open": "user-menu-trigger-module-scss-module__4BL5aa__open",
  "plan": "user-menu-trigger-module-scss-module__4BL5aa__plan",
  "root": "user-menu-trigger-module-scss-module__4BL5aa__root",
  "text": "user-menu-trigger-module-scss-module__4BL5aa__text",
  "user_icon": "user-menu-trigger-module-scss-module__4BL5aa__user_icon",
  "wrapper": "user-menu-trigger-module-scss-module__4BL5aa__wrapper",
});
